// Math.floor is much faster than parseInt
// https://jsperf.com/test-parseint-and-math-floor
const generatePseudoRandomNumber = () => Math.floor(Math.random() * 10000);

export default generatePseudoRandomNumber;
